import React from 'react';

import PropTypes from 'prop-types';

import {
    Typography,
} from 'wanderu-components';
import { transformTimeTo12HourFormat } from 'wanderu-utils';

// we reference some depart/arrive classes like styles[foo] instead of styles.foo
// eslint-disable-next-line css-modules/no-unused-class
import styles from './ScheduleEndpoint.scss';

const Station = (props) => {
    const {
        name,
        type,
    } = props;

    return (
        <Typography
            className={`${styles.station} ${styles[type]}`}
            variant="caption"
        >
            {name}
        </Typography>
    );
};

function ScheduleEndpoint(props) {
    const {
        className,
        cityName,
        dateTime,
        name,
        type,
    } = props;

    return (
        <div className={className}>
            <div className={styles.timeContainer}>
                <div
                    aria-label={type}
                    aria-live="polite"
                    className={`${styles.time} ${styles[type]}`}
                >
                    {transformTimeTo12HourFormat(dateTime)}
                </div>
            </div>
            <Typography variant="overline">{cityName}</Typography>
            <Station
                name={name}
                type={type}
            />
        </div>
    );
}

ScheduleEndpoint.propTypes = {
    cityName: PropTypes.string.isRequired,
    className: PropTypes.string,
    dateTime: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOf([
        'arrive',
        'depart',
    ]).isRequired,
};

ScheduleEndpoint.defaultProps = {
    className: '',
    duration: null,
};

export {
    ScheduleEndpoint,
};
export default ScheduleEndpoint;
